import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { resolveDirective as V, openBlock as l, createBlock as ve, Transition as me, withCtx as G, withDirectives as W, createElementBlock as d, normalizeClass as E, normalizeStyle as T, createElementVNode as D, renderSlot as Y, toDisplayString as m, createCommentVNode as M, createVNode as be, TransitionGroup as _e, Fragment as k, renderList as S, vModelSelect as J, createTextVNode as Me, vShow as we } from "vue";
var X = 6e4, ke = function(t) {
  var s = new Date(t.getTime()), a = s.getTimezoneOffset();
  s.setSeconds(0, 0);
  var r = s.getTime() % X;
  return a * X + r;
};
function Se(e) {
  return e instanceof Date;
}
var ue = Se, $ = ke, Te = ue, N = 36e5, A = 6e4, Ye = 2, Fe = /[T ]/, Oe = /:/, xe = /^(\d{2})$/, Ie = [
  /^([+-]\d{2})$/,
  /^([+-]\d{3})$/,
  /^([+-]\d{4})$/
], Ee = /^(\d{4})/, Ce = [
  /^([+-]\d{4})/,
  /^([+-]\d{5})/,
  /^([+-]\d{6})/
], Le = /^-(\d{2})$/, We = /^-?(\d{3})$/, $e = /^-?(\d{2})-?(\d{2})$/, Ne = /^-?W(\d{2})$/, He = /^-?W(\d{2})-?(\d{1})$/, Re = /^(\d{2}([.,]\d*)?)$/, Ae = /^(\d{2}):?(\d{2}([.,]\d*)?)$/, Be = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/, ze = /([Z+-].*)$/, Ke = /^(Z)$/, Pe = /^([+-])(\d{2})$/, Ue = /^([+-])(\d{2}):?(\d{2})$/;
function Ve(e, t) {
  if (Te(e))
    return new Date(e.getTime());
  if (typeof e != "string")
    return new Date(e);
  var s = t || {}, a = s.additionalDigits;
  a == null ? a = Ye : a = Number(a);
  var r = Ge(e), n = Je(r.date, a), h = n.year, f = n.restDateString, i = Xe(f, h);
  if (i) {
    var u = i.getTime(), o = 0, y;
    if (r.time && (o = Ze(r.time)), r.timezone)
      y = je(r.timezone) * A;
    else {
      var c = u + o, _ = new Date(c);
      y = $(_);
      var I = new Date(c);
      I.setDate(_.getDate() + 1);
      var U = $(I) - $(_);
      U > 0 && (y += U);
    }
    return new Date(u + o + y);
  } else
    return new Date(e);
}
function Ge(e) {
  var t = {}, s = e.split(Fe), a;
  if (Oe.test(s[0]) ? (t.date = null, a = s[0]) : (t.date = s[0], a = s[1]), a) {
    var r = ze.exec(a);
    r ? (t.time = a.replace(r[1], ""), t.timezone = r[1]) : t.time = a;
  }
  return t;
}
function Je(e, t) {
  var s = Ie[t], a = Ce[t], r;
  if (r = Ee.exec(e) || a.exec(e), r) {
    var n = r[1];
    return {
      year: parseInt(n, 10),
      restDateString: e.slice(n.length)
    };
  }
  if (r = xe.exec(e) || s.exec(e), r) {
    var h = r[1];
    return {
      year: parseInt(h, 10) * 100,
      restDateString: e.slice(h.length)
    };
  }
  return {
    year: null
  };
}
function Xe(e, t) {
  if (t === null)
    return null;
  var s, a, r, n;
  if (e.length === 0)
    return a = new Date(0), a.setUTCFullYear(t), a;
  if (s = Le.exec(e), s)
    return a = new Date(0), r = parseInt(s[1], 10) - 1, a.setUTCFullYear(t, r), a;
  if (s = We.exec(e), s) {
    a = new Date(0);
    var h = parseInt(s[1], 10);
    return a.setUTCFullYear(t, 0, h), a;
  }
  if (s = $e.exec(e), s) {
    a = new Date(0), r = parseInt(s[1], 10) - 1;
    var f = parseInt(s[2], 10);
    return a.setUTCFullYear(t, r, f), a;
  }
  if (s = Ne.exec(e), s)
    return n = parseInt(s[1], 10) - 1, Z(t, n);
  if (s = He.exec(e), s) {
    n = parseInt(s[1], 10) - 1;
    var i = parseInt(s[2], 10) - 1;
    return Z(t, n, i);
  }
  return null;
}
function Ze(e) {
  var t, s, a;
  if (t = Re.exec(e), t)
    return s = parseFloat(t[1].replace(",", ".")), s % 24 * N;
  if (t = Ae.exec(e), t)
    return s = parseInt(t[1], 10), a = parseFloat(t[2].replace(",", ".")), s % 24 * N + a * A;
  if (t = Be.exec(e), t) {
    s = parseInt(t[1], 10), a = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return s % 24 * N + a * A + r * 1e3;
  }
  return null;
}
function je(e) {
  var t, s;
  return t = Ke.exec(e), t ? 0 : (t = Pe.exec(e), t ? (s = parseInt(t[2], 10) * 60, t[1] === "+" ? -s : s) : (t = Ue.exec(e), t ? (s = parseInt(t[2], 10) * 60 + parseInt(t[3], 10), t[1] === "+" ? -s : s) : 0));
}
function Z(e, t, s) {
  t = t || 0, s = s || 0;
  var a = new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var r = a.getUTCDay() || 7, n = t * 7 + s + 1 - r;
  return a.setUTCDate(a.getUTCDate() + n), a;
}
var p = Ve, Qe = p;
function qe(e) {
  var t = Qe(e), s = new Date(0);
  return s.setFullYear(t.getFullYear(), 0, 1), s.setHours(0, 0, 0, 0), s;
}
var et = qe, tt = p;
function st(e) {
  var t = tt(e);
  return t.setHours(0, 0, 0, 0), t;
}
var fe = st, j = fe, Q = 6e4, at = 864e5;
function rt(e, t) {
  var s = j(e), a = j(t), r = s.getTime() - s.getTimezoneOffset() * Q, n = a.getTime() - a.getTimezoneOffset() * Q;
  return Math.round((r - n) / at);
}
var nt = rt, it = p, ot = et, ht = nt;
function lt(e) {
  var t = it(e), s = ht(t, ot(t)), a = s + 1;
  return a;
}
var dt = lt, ct = p;
function ut(e, t) {
  var s = t && Number(t.weekStartsOn) || 0, a = ct(e), r = a.getDay(), n = (r < s ? 7 : 0) + r - s;
  return a.setDate(a.getDate() - n), a.setHours(0, 0, 0, 0), a;
}
var De = ut, ft = De;
function Dt(e) {
  return ft(e, { weekStartsOn: 1 });
}
var K = Dt, pt = p, q = K;
function yt(e) {
  var t = pt(e), s = t.getFullYear(), a = new Date(0);
  a.setFullYear(s + 1, 0, 4), a.setHours(0, 0, 0, 0);
  var r = q(a), n = new Date(0);
  n.setFullYear(s, 0, 4), n.setHours(0, 0, 0, 0);
  var h = q(n);
  return t.getTime() >= r.getTime() ? s + 1 : t.getTime() >= h.getTime() ? s : s - 1;
}
var pe = yt, gt = pe, vt = K;
function mt(e) {
  var t = gt(e), s = new Date(0);
  s.setFullYear(t, 0, 4), s.setHours(0, 0, 0, 0);
  var a = vt(s);
  return a;
}
var bt = mt, _t = p, Mt = K, wt = bt, kt = 6048e5;
function St(e) {
  var t = _t(e), s = Mt(t).getTime() - wt(t).getTime();
  return Math.round(s / kt) + 1;
}
var Tt = St, Yt = ue;
function Ft(e) {
  if (Yt(e))
    return !isNaN(e);
  throw new TypeError(toString.call(e) + " is not an instance of Date");
}
var ye = Ft;
function Ot() {
  var e = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  };
  function t(s, a, r) {
    r = r || {};
    var n;
    return typeof e[s] == "string" ? n = e[s] : a === 1 ? n = e[s].one : n = e[s].other.replace("{{count}}", a), r.addSuffix ? r.comparison > 0 ? "in " + n : n + " ago" : n;
  }
  return {
    localize: t
  };
}
var xt = Ot, It = [
  "M",
  "MM",
  "Q",
  "D",
  "DD",
  "DDD",
  "DDDD",
  "d",
  "E",
  "W",
  "WW",
  "YY",
  "YYYY",
  "GG",
  "GGGG",
  "H",
  "HH",
  "h",
  "hh",
  "m",
  "mm",
  "s",
  "ss",
  "S",
  "SS",
  "SSS",
  "Z",
  "ZZ",
  "X",
  "x"
];
function Et(e) {
  var t = [];
  for (var s in e)
    e.hasOwnProperty(s) && t.push(s);
  var a = It.concat(t).sort().reverse(), r = new RegExp(
    "(\\[[^\\[]*\\])|(\\\\)?(" + a.join("|") + "|.)",
    "g"
  );
  return r;
}
var Ct = Et, Lt = Ct;
function Wt() {
  var e = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], t = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], s = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], a = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], r = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], n = ["AM", "PM"], h = ["am", "pm"], f = ["a.m.", "p.m."], i = {
    MMM: function(o) {
      return e[o.getMonth()];
    },
    MMMM: function(o) {
      return t[o.getMonth()];
    },
    dd: function(o) {
      return s[o.getDay()];
    },
    ddd: function(o) {
      return a[o.getDay()];
    },
    dddd: function(o) {
      return r[o.getDay()];
    },
    A: function(o) {
      return o.getHours() / 12 >= 1 ? n[1] : n[0];
    },
    a: function(o) {
      return o.getHours() / 12 >= 1 ? h[1] : h[0];
    },
    aa: function(o) {
      return o.getHours() / 12 >= 1 ? f[1] : f[0];
    }
  }, u = ["M", "D", "DDD", "d", "Q", "W"];
  return u.forEach(function(o) {
    i[o + "o"] = function(y, c) {
      return $t(c[o](y));
    };
  }), {
    formatters: i,
    formattingTokensRegExp: Lt(i)
  };
}
function $t(e) {
  var t = e % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}
var Nt = Wt, Ht = xt, Rt = Nt, At = {
  distanceInWords: Ht(),
  format: Rt()
}, ee = dt, te = Tt, se = pe, Bt = p, zt = ye, ae = At;
function Kt(e, t, s) {
  var a = t ? String(t) : "YYYY-MM-DDTHH:mm:ss.SSSZ", r = s || {}, n = r.locale, h = ae.format.formatters, f = ae.format.formattingTokensRegExp;
  n && n.format && n.format.formatters && (h = n.format.formatters, n.format.formattingTokensRegExp && (f = n.format.formattingTokensRegExp));
  var i = Bt(e);
  if (!zt(i))
    return "Invalid Date";
  var u = Pt(a, h, f);
  return u(i);
}
var B = {
  M: function(e) {
    return e.getMonth() + 1;
  },
  MM: function(e) {
    return v(e.getMonth() + 1, 2);
  },
  Q: function(e) {
    return Math.ceil((e.getMonth() + 1) / 3);
  },
  D: function(e) {
    return e.getDate();
  },
  DD: function(e) {
    return v(e.getDate(), 2);
  },
  DDD: function(e) {
    return ee(e);
  },
  DDDD: function(e) {
    return v(ee(e), 3);
  },
  d: function(e) {
    return e.getDay();
  },
  E: function(e) {
    return e.getDay() || 7;
  },
  W: function(e) {
    return te(e);
  },
  WW: function(e) {
    return v(te(e), 2);
  },
  YY: function(e) {
    return v(e.getFullYear(), 4).substr(2);
  },
  YYYY: function(e) {
    return v(e.getFullYear(), 4);
  },
  GG: function(e) {
    return String(se(e)).substr(2);
  },
  GGGG: function(e) {
    return se(e);
  },
  H: function(e) {
    return e.getHours();
  },
  HH: function(e) {
    return v(e.getHours(), 2);
  },
  h: function(e) {
    var t = e.getHours();
    return t === 0 ? 12 : t > 12 ? t % 12 : t;
  },
  hh: function(e) {
    return v(B.h(e), 2);
  },
  m: function(e) {
    return e.getMinutes();
  },
  mm: function(e) {
    return v(e.getMinutes(), 2);
  },
  s: function(e) {
    return e.getSeconds();
  },
  ss: function(e) {
    return v(e.getSeconds(), 2);
  },
  S: function(e) {
    return Math.floor(e.getMilliseconds() / 100);
  },
  SS: function(e) {
    return v(Math.floor(e.getMilliseconds() / 10), 2);
  },
  SSS: function(e) {
    return v(e.getMilliseconds(), 3);
  },
  Z: function(e) {
    return re(e.getTimezoneOffset(), ":");
  },
  ZZ: function(e) {
    return re(e.getTimezoneOffset());
  },
  X: function(e) {
    return Math.floor(e.getTime() / 1e3);
  },
  x: function(e) {
    return e.getTime();
  }
};
function Pt(e, t, s) {
  var a = e.match(s), r = a.length, n, h;
  for (n = 0; n < r; n++)
    h = t[a[n]] || B[a[n]], h ? a[n] = h : a[n] = Ut(a[n]);
  return function(f) {
    for (var i = "", u = 0; u < r; u++)
      a[u] instanceof Function ? i += a[u](f, B) : i += a[u];
    return i;
  };
}
function Ut(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|]$/g, "") : e.replace(/\\/g, "");
}
function re(e, t) {
  t = t || "";
  var s = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.floor(a / 60), n = a % 60;
  return s + v(r, 2) + t + v(n, 2);
}
function v(e, t) {
  for (var s = Math.abs(e).toString(); s.length < t; )
    s = "0" + s;
  return s;
}
var g = Kt, Vt = p;
function Gt(e) {
  var t = Vt(e), s = t.getFullYear(), a = t.getMonth(), r = new Date(0);
  return r.setFullYear(s, a + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
var P = Gt, Jt = p, Xt = P;
function Zt(e, t) {
  var s = Jt(e), a = Number(t), r = s.getMonth() + a, n = new Date(0);
  n.setFullYear(s.getFullYear(), r, 1), n.setHours(0, 0, 0, 0);
  var h = Xt(n);
  return s.setMonth(r, Math.min(h, s.getDate())), s;
}
var z = Zt, jt = z;
function Qt(e, t) {
  var s = Number(t);
  return jt(e, -s);
}
var O = Qt, qt = p;
function es(e) {
  var t = qt(e), s = t.getMonth();
  return t.setFullYear(t.getFullYear(), s + 1, 0), t.setHours(0, 0, 0, 0), t;
}
var ts = es, ss = p;
function as(e) {
  var t = ss(e), s = t.getMonth();
  return s;
}
var rs = as, ns = p, is = P;
function os(e, t) {
  var s = ns(e), a = Number(t), r = s.getFullYear(), n = s.getDate(), h = new Date(0);
  h.setFullYear(r, a, 15), h.setHours(0, 0, 0, 0);
  var f = is(h);
  return s.setMonth(a, Math.min(n, f)), s;
}
var H = os, hs = p;
function ls(e) {
  var t = hs(e), s = t.getFullYear();
  return s;
}
var C = ls, ds = p;
function cs(e, t) {
  var s = ds(e), a = Number(t);
  return s.setFullYear(a), s;
}
var R = cs, ne = p;
function us(e, t) {
  var s = ne(e), a = ne(t);
  return s.getFullYear() === a.getFullYear() && s.getMonth() === a.getMonth();
}
var F = us, ie = fe;
function fs(e, t) {
  var s = ie(e), a = ie(t);
  return s.getTime() === a.getTime();
}
var Ds = fs, ps = p;
function ys(e, t) {
  var s = ps(e), a = Number(t);
  return s.setDate(s.getDate() + a), s;
}
var L = ys, gs = L;
function vs(e, t) {
  var s = Number(t);
  return gs(e, -s);
}
var oe = vs, ms = L;
function bs(e, t) {
  var s = Number(t), a = s * 7;
  return ms(e, a);
}
var ge = bs, _s = ge;
function Ms(e, t) {
  var s = Number(t);
  return _s(e, -s);
}
var ws = Ms, ks = p;
function Ss(e) {
  var t = ks(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
var Ts = Ss, Ys = p;
function Fs(e, t) {
  var s = t && Number(t.weekStartsOn) || 0, a = Ys(e), r = a.getDay(), n = (r < s ? -7 : 0) + 6 - (r - s);
  return a.setDate(a.getDate() + n), a.setHours(23, 59, 59, 999), a;
}
var Os = Fs, he = p;
function xs(e, t) {
  var s = he(e), a = he(t);
  return s.getTime() < a.getTime();
}
var b = xs, le = p;
function Is(e, t) {
  var s = le(e), a = le(t);
  return s.getTime() > a.getTime();
}
var x = Is;
const Es = (e, t, s) => {
  var a;
  return function() {
    var r = this, n = arguments, h = function() {
      a = null, s || e.apply(r, n);
    }, f = s && !a;
    clearTimeout(a), a = setTimeout(h, t), f && e.apply(r, n);
  };
}, w = (e) => JSON.parse(JSON.stringify(e)), Cs = (e, t) => {
  if (!e)
    return null;
  if (typeof e.closest == "function")
    return e.closest(t) || null;
  for (; e; ) {
    if (e.matches(t))
      return e;
    e = e.parentElement;
  }
  return null;
}, Ls = (e) => {
  let t = "", s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let a = 0; a < e; a++)
    t += s.charAt(Math.floor(Math.random() * s.length));
  return t;
};
const Ws = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [a, r] of t)
    s[a] = r;
  return s;
}, $s = {
  name: "AirbnbStyleDatepicker",
  props: {
    triggerElementId: {
      type: String
    },
    dateOne: {
      type: [String, Date]
    },
    dateTwo: {
      type: [String, Date]
    },
    minDate: {
      type: [String, Date]
    },
    endDate: {
      type: [String, Date]
    },
    mode: {
      type: String,
      default: "range"
    },
    offsetY: {
      type: Number,
      default: 0
    },
    offsetX: {
      type: Number,
      default: 0
    },
    monthsToShow: {
      type: Number,
      default: 2
    },
    startOpen: {
      type: Boolean
    },
    fullscreenMobile: {
      type: Boolean
    },
    inline: {
      type: Boolean
    },
    mobileHeader: {
      type: String
    },
    disabledDates: {
      type: Array,
      default: () => []
    },
    enabledDates: {
      type: Array,
      default: () => []
    },
    showActionButtons: {
      type: Boolean,
      default: !0
    },
    showShortcutsMenuTrigger: {
      type: Boolean,
      default: !0
    },
    showMonthYearSelect: {
      type: Boolean,
      default: !1
    },
    yearsForSelect: {
      type: Number,
      default: 10
    },
    isTest: {
      type: Boolean,
      default: () => process.env.NODE_ENV === "test"
    },
    trigger: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      wrapperId: "airbnb-style-datepicker-wrapper-" + Ls(5),
      dateFormat: "YYYY-MM-DD",
      dateLabelFormat: "dddd, MMMM D, YYYY",
      showDatepicker: !1,
      showKeyboardShortcutsMenu: !1,
      showMonths: 2,
      colors: {
        selected: "#00a699",
        inRange: "#66e2da",
        selectedText: "#fff",
        text: "#565a5c",
        inRangeBorder: "#33dacd",
        disabled: "#fff"
      },
      sundayFirst: !1,
      ariaLabels: {
        chooseDate: (e) => e,
        chooseStartDate: (e) => `Choose ${e} as your start date.`,
        chooseEndDate: (e) => `Choose ${e} as your end date.`,
        selectedDate: (e) => `Selected. ${e}`,
        selectedStartDate: (e) => `Selected ${e} as your start date.`,
        selectedEndDate: (e) => `Selected ${e} as your end date.`,
        selectedStartAndEndDate: (e) => `Selected ${e} as your start and end date.`,
        unavailableDate: (e) => `Not available. ${e}`,
        previousMonth: "Move backward to switch to the previous month.",
        nextMonth: "Move forward to switch to the next month.",
        closeDatepicker: "Close calendar",
        openKeyboardShortcutsMenu: "Open keyboard shortcuts menu.",
        closeKeyboardShortcutsMenu: "Close keyboard shortcuts menu"
      },
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      daysShort: ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"],
      texts: {
        apply: "Apply",
        cancel: "Cancel",
        keyboardShortcuts: "Keyboard Shortcuts"
      },
      keyboardShortcuts: [{
        symbol: "↵",
        label: "Select the date in focus",
        symbolDescription: "Enter key"
      }, {
        symbol: "←/→",
        label: "Move backward (left) and forward (down) by one day.",
        symbolDescription: "Left or right arrow keys"
      }, {
        symbol: "↑/↓",
        label: "Move backward (up) and forward (down) by one week.",
        symbolDescription: "Up or down arrow keys"
      }, {
        symbol: "PgUp/PgDn",
        label: "Switch months.",
        symbolDescription: "PageUp and PageDown keys"
      }, {
        symbol: "Home/End",
        label: "Go to the first or last day of a week.",
        symbolDescription: "Home or End keys"
      }, {
        symbol: "Esc",
        label: "Close this panel",
        symbolDescription: "Escape key"
      }, {
        symbol: "?",
        label: "Open this panel",
        symbolDescription: "Question mark"
      }],
      keys: {
        arrowDown: 40,
        arrowUp: 38,
        arrowRight: 39,
        arrowLeft: 37,
        enter: 13,
        pgUp: 33,
        pgDn: 34,
        end: 35,
        home: 36,
        questionMark: 191,
        esc: 27
      },
      startingDate: "",
      months: [],
      years: [],
      width: 320,
      selectedDate1: "",
      selectedDate2: "",
      isSelectingDate1: !0,
      hoverDate: "",
      focusedDate: "",
      alignRight: !1,
      triggerPosition: {},
      triggerWrapperPosition: {},
      viewportWidth: void 0,
      isMobile: void 0,
      isTablet: void 0,
      triggerElement: void 0
    };
  },
  computed: {
    wrapperClasses() {
      return {
        "asd__wrapper--datepicker-open": this.showDatepicker,
        "asd__wrapper--full-screen": this.showFullscreen,
        "asd__wrapper--inline": this.inline
      };
    },
    wrapperStyles() {
      return {
        position: this.inline ? "static" : "absolute",
        top: this.inline ? "0" : this.triggerPosition.height + this.offsetY + "px",
        left: this.alignRight ? "" : this.triggerPosition.left - this.triggerWrapperPosition.left + this.offsetX + "px",
        right: this.alignRight ? this.triggerWrapperPosition.right - this.triggerPosition.right + this.offsetX + "px" : "",
        width: this.width * this.showMonths + "px",
        zIndex: this.inline ? "0" : "100"
      };
    },
    innerStyles() {
      return {
        "margin-left": this.showFullscreen ? "-" + this.viewportWidth : `-${this.width}px`
      };
    },
    keyboardShortcutsMenuStyles() {
      return {
        left: this.showFullscreen ? this.viewportWidth : `${this.width}px`
      };
    },
    monthWidthStyles() {
      return {
        width: this.showFullscreen ? this.viewportWidth : this.width + "px"
      };
    },
    mobileHeaderFallback() {
      return this.mode === "range" ? "Select dates" : "Select date";
    },
    showFullscreen() {
      return this.isMobile && this.fullscreenMobile;
    },
    datesSelected() {
      return !!(this.selectedDate1 && this.selectedDate1 !== "" || this.selectedDate2 && this.selectedDate2 !== "");
    },
    allDatesSelected() {
      return !!(this.selectedDate1 && this.selectedDate1 !== "" && this.selectedDate2 && this.selectedDate2 !== "");
    },
    hasMinDate() {
      return !!(this.minDate && this.minDate !== "");
    },
    isRangeMode() {
      return this.mode === "range";
    },
    isSingleMode() {
      return this.mode === "single";
    },
    datepickerWidth() {
      return this.width * this.showMonths;
    },
    datePropsCompound() {
      return this.dateOne + this.dateTwo;
    },
    isDateTwoBeforeDateOne() {
      return this.dateTwo ? b(this.dateTwo, this.dateOne) : !1;
    },
    visibleMonths() {
      const e = this.months.filter((s, a) => a > 0), t = [];
      for (let s = 0; s < this.showMonths; s++)
        t.push(s);
      return t.map((s, a) => e[a].firstDateOfMonth);
    }
  },
  watch: {
    selectedDate1(e, t) {
      let s = !e || e === "" ? "" : g(e, this.dateFormat);
      this.$emit("date-one-selected", s);
    },
    selectedDate2(e, t) {
      let s = !e || e === "" ? "" : g(e, this.dateFormat);
      this.$emit("date-two-selected", s);
    },
    mode(e, t) {
      this.setStartDates();
    },
    minDate() {
      this.setStartDates(), this.generateMonths(), this.generateYears();
    },
    endDate() {
      this.generateYears();
    },
    datePropsCompound(e) {
      this.dateOne !== this.selectedDate1 && (this.startingDate = this.dateOne, this.setStartDates(), this.generateMonths(), this.generateYears()), this.isDateTwoBeforeDateOne && (this.selectedDate2 = "", this.$emit("date-two-selected", ""));
    },
    trigger(e, t) {
      e && this.openDatepicker();
    }
  },
  created() {
    this.setupDatepicker(), this.sundayFirst && this.setSundayToFirstDayInWeek();
  },
  mounted() {
    this.viewportWidth = window.innerWidth + "px", this.isMobile = window.innerWidth < 768, this.isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024, this._handleWindowResizeEvent = Es(() => {
      this.positionDatepicker(), this.setStartDates();
    }, 200), this._handleWindowClickEvent = (e) => {
      e.target.id === this.triggerElementId && (e.stopPropagation(), e.preventDefault(), this.toggleDatepicker());
    }, window.addEventListener("resize", this._handleWindowResizeEvent), window.addEventListener("click", this._handleWindowClickEvent), this.triggerElement = this.isTest ? document.createElement("input") : document.getElementById(this.triggerElementId), this.setStartDates(), this.generateMonths(), this.generateYears(), (this.startOpen || this.inline) && this.openDatepicker(), this.$el.addEventListener("keyup", this.handleKeyboardInput), this.$el.addEventListener("keydown", this.trapKeyboardInput), this.triggerElement.addEventListener("keyup", this.handleTriggerInput);
  },
  unmounted() {
    window.removeEventListener("resize", this._handleWindowResizeEvent), window.removeEventListener("click", this._handleWindowClickEvent), this.$el.removeEventListener("keyup", this.handleKeyboardInput), this.$el.removeEventListener("keydown", this.trapKeyboardInput), this.triggerElement.removeEventListener("keyup", this.handleTriggerInput);
  },
  methods: {
    getDayStyles(e) {
      const t = this.isSelected(e), s = this.isInRange(e), a = this.isDisabled(e);
      let r = {
        width: (this.width - 30) / 7 + "px",
        background: t ? this.colors.selected : s ? this.colors.inRange : "",
        color: t ? this.colors.selectedText : s ? this.colors.selectedText : this.colors.text,
        border: t ? "1px double " + this.colors.selected : s && this.allDatesSelected ? "1px double " + this.colors.inRangeBorder : ""
      };
      return a && (r.background = this.colors.disabled), r;
    },
    getAriaLabelForDate(e) {
      const t = g(e, this.dateLabelFormat);
      return this.isDisabled(e) ? this.ariaLabels.unavailableDate(t) : this.isSelected(e) ? this.isRangeMode ? e === this.selectedDate1 ? e === this.selectedDate2 ? this.ariaLabels.selectedStartAndEndDate(t) : this.ariaLabels.selectedStartDate(t) : this.ariaLabels.selectedEndDate(t) : this.ariaLabels.selectedDate(t) : this.isRangeMode ? this.isSelectingDate1 || b(e, this.selectedDate1) ? this.ariaLabels.chooseStartDate(t) : this.ariaLabels.chooseEndDate(t) : this.ariaLabels.chooseDate(t);
    },
    handleClickOutside(e) {
      e.target.id === this.triggerElementId || !this.showDatepicker || this.inline || this.closeDatepicker();
    },
    shouldHandleInput(e, t) {
      return e.keyCode === t && (!e.shiftKey || e.keyCode === 191) && this.showDatepicker;
    },
    handleTriggerInput(e) {
      this.mode === "single" && this.setDateFromText(e.target.value);
    },
    trapKeyboardInput(e) {
      const t = Object.keys(this.keys).map((a) => this.keys[a]);
      t.splice(t.indexOf(13), 1), t.indexOf(e.keyCode) > -1 && e.preventDefault();
    },
    handleKeyboardInput(e) {
      if (this.shouldHandleInput(e, this.keys.esc))
        this.showKeyboardShortcutsMenu ? this.closeKeyboardShortcutsMenu() : this.closeDatepicker();
      else if (!this.showKeyboardShortcutsMenu)
        if (this.shouldHandleInput(e, this.keys.arrowDown)) {
          const t = ge(this.focusedDate, 1), s = !F(t, this.focusedDate);
          this.setFocusedDate(t), s && this.nextMonth();
        } else if (this.shouldHandleInput(e, this.keys.arrowUp)) {
          const t = ws(this.focusedDate, 1), s = !F(t, this.focusedDate);
          this.setFocusedDate(t), s && this.previousMonth();
        } else if (this.shouldHandleInput(e, this.keys.arrowRight)) {
          const t = L(this.focusedDate, 1), s = !F(t, this.focusedDate);
          this.setFocusedDate(t), s && this.nextMonth();
        } else if (this.shouldHandleInput(e, this.keys.arrowLeft)) {
          const t = oe(this.focusedDate, 1), s = !F(t, this.focusedDate);
          this.setFocusedDate(t), s && this.previousMonth();
        } else if (this.shouldHandleInput(e, this.keys.enter)) {
          const t = e.target;
          !this.showKeyboardShortcutsMenu && t && t.tagName === "TD" && this.selectDate(this.focusedDate);
        } else if (this.shouldHandleInput(e, this.keys.pgUp))
          this.setFocusedDate(O(this.focusedDate, 1)), this.previousMonth();
        else if (this.shouldHandleInput(e, this.keys.pgDn))
          this.setFocusedDate(z(this.focusedDate, 1)), this.nextMonth();
        else if (this.shouldHandleInput(e, this.keys.home)) {
          const t = De(this.focusedDate, {
            weekStartsOn: this.sundayFirst ? 0 : 1
          }), s = !F(t, this.focusedDate);
          this.setFocusedDate(t), s && this.previousMonth();
        } else if (this.shouldHandleInput(e, this.keys.end)) {
          const t = Os(this.focusedDate, {
            weekStartsOn: this.sundayFirst ? 0 : 1
          }), s = !F(t, this.focusedDate);
          this.setFocusedDate(t), s && this.nextMonth();
        } else
          this.shouldHandleInput(e, this.keys.questionMark) && this.openKeyboardShortcutsMenu();
    },
    setDateFromText(e) {
      if (!e || e.length < 10)
        return;
      const t = e.match(/^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/), s = e.match(/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])[.](0[1-9]|1[0-2])[.](\d{4})$/);
      if (!t && !s)
        return;
      s && (e = `${e.substring(6, 10)}-${e.substring(3, 5)}-${e.substring(0, 2)}`);
      const a = new Date(e);
      if (!ye(a))
        return;
      const r = g(a, this.dateFormat);
      this.isDateDisabled(r) || this.isBeforeMinDate(r) || this.isAfterEndDate(r) || (this.startingDate = O(r, 1), this.generateMonths(), this.generateYears(), this.selectDate(r));
    },
    isMonthDisabled(e, t) {
      const s = new Date(e, t);
      return this.hasMinDate && b(s, Ts(this.minDate)) ? !0 : this.isAfterEndDate(s);
    },
    generateMonths() {
      this.months = [];
      let e = this.startingDate;
      for (let t = 0; t < this.showMonths + 2; t++)
        this.months.push(this.getMonth(e)), e = this.addMonths(e);
    },
    generateYears() {
      if (!this.showMonthYearSelect)
        return;
      this.years = [];
      const e = C(this.startingDate), t = this.minDate ? C(this.minDate) : e - this.yearsForSelect, s = this.endDate ? C(this.endDate) : e + this.yearsForSelect;
      for (var a = t; a <= s; a++)
        this.years.push(a.toString());
    },
    setupDatepicker() {
      if (this.$options.ariaLabels && (this.ariaLabels = w(this.$options.ariaLabels)), this.$options.keyboardShortcuts && (this.keyboardShortcuts = w(this.$options.keyboardShortcuts)), this.$options.dateLabelFormat && (this.dateLabelFormat = w(this.$options.dateLabelFormat)), this.$options.sundayFirst && (this.sundayFirst = w(this.$options.sundayFirst)), this.$options.colors) {
        const e = w(this.$options.colors);
        this.colors.selected = e.selected || this.colors.selected, this.colors.inRange = e.inRange || this.colors.inRange, this.colors.selectedText = e.selectedText || this.colors.selectedText, this.colors.text = e.text || this.colors.text, this.colors.inRangeBorder = e.inRangeBorder || this.colors.inRangeBorder, this.colors.disabled = e.disabled || this.colors.disabled;
      }
      if (this.$options.monthNames && this.$options.monthNames.length === 12 && (this.monthNames = w(this.$options.monthNames)), this.$options.days && this.$options.days.length === 7 && (this.days = w(this.$options.days)), this.$options.daysShort && this.$options.daysShort.length === 7 && (this.daysShort = w(this.$options.daysShort)), this.$options.texts) {
        const e = w(this.$options.texts);
        this.texts.apply = e.apply || this.texts.apply, this.texts.cancel = e.cancel || this.texts.cancel;
      }
    },
    setStartDates() {
      let e = this.dateOne || new Date();
      this.hasMinDate && b(e, this.minDate) && (e = this.minDate), this.startingDate = this.subtractMonths(e), this.selectedDate1 = this.dateOne, this.selectedDate2 = this.dateTwo, this.focusedDate = e;
    },
    setSundayToFirstDayInWeek() {
      const e = this.days.pop();
      this.days.unshift(e);
      const t = this.daysShort.pop();
      this.daysShort.unshift(t);
    },
    getMonth(e) {
      const t = g(e, "YYYY-MM-01"), s = g(e, "YYYY"), a = parseInt(g(e, "M")), r = this.monthNames[a - 1];
      return {
        year: s,
        firstDateOfMonth: t,
        monthName: r,
        monthNumber: a,
        weeks: this.getWeeks(t)
      };
    },
    getWeeks(e) {
      const t = {
        dayNumber: 0
      }, s = P(e), a = g(e, "YYYY"), r = g(e, "MM");
      let n = parseInt(g(e, this.sundayFirst ? "d" : "E"));
      this.sundayFirst && n++;
      let h = [], f = [];
      for (let i = 1; i < n; i++)
        f.push(t);
      for (let i = 0; i < s; i++) {
        let u = i >= s - 1, o = i + 1, y = o < 10 ? "0" + o : o;
        if (f.push({
          dayNumber: o,
          dayNumberFull: y,
          fullDate: a + "-" + r + "-" + y
        }), f.length === 7)
          h.push(f), f = [];
        else if (u) {
          for (let c = 0; c < 7 - f.length; c++)
            f.push(t);
          h.push(f), f = [];
        }
      }
      return h;
    },
    selectDate(e) {
      if (!(this.isBeforeMinDate(e) || this.isAfterEndDate(e) || this.isDateDisabled(e))) {
        if (this.mode === "single") {
          this.selectedDate1 = e, this.closeDatepicker();
          return;
        }
        this.isSelectingDate1 || b(e, this.selectedDate1) ? (this.selectedDate1 = e, this.isSelectingDate1 = !1, b(this.selectedDate2, e) && (this.selectedDate2 = "")) : (this.selectedDate2 = e, this.isSelectingDate1 = !0, x(this.selectedDate1, e) ? this.selectedDate1 = "" : this.showActionButtons && this.$refs["apply-button"].focus());
      }
    },
    setHoverDate(e) {
      this.hoverDate = e;
    },
    setFocusedDate(e) {
      const t = g(e, this.dateFormat);
      this.focusedDate = t;
      const s = this.$refs[`date-${t}`];
      s && setTimeout(function() {
        s[0].focus();
      }, 10);
    },
    resetFocusedDate(e) {
      if (this.focusedDate && !this.isDateVisible(this.focusedDate)) {
        const t = e ? 0 : this.visibleMonths.length - 1, s = this.visibleMonths[t], a = rs(s), r = C(s), n = R(H(this.focusedDate, a), r);
        this.focusedDate = g(n, this.dateFormat);
      }
    },
    isToday(e) {
      return g(new Date(), this.dateFormat) === e;
    },
    isSameDate(e, t) {
      return Ds(e, t);
    },
    isSelected(e) {
      if (e)
        return this.selectedDate1 === e || this.selectedDate2 === e;
    },
    isInRange(e) {
      return !this.allDatesSelected || this.isSingleMode ? !1 : x(e, this.selectedDate1) && b(e, this.selectedDate2) || x(e, this.selectedDate1) && b(e, this.hoverDate) && !this.allDatesSelected;
    },
    isBeforeMinDate(e) {
      return this.minDate ? b(e, this.minDate) : !1;
    },
    isAfterEndDate(e) {
      return this.endDate ? x(e, this.endDate) : !1;
    },
    isDateVisible(e) {
      if (!e)
        return !1;
      const t = oe(this.visibleMonths[0], 1), s = L(ts(this.visibleMonths[this.monthsToShow - 1]), 1);
      return x(e, t) && b(e, s);
    },
    isDateDisabled(e) {
      return this.enabledDates.length > 0 ? this.enabledDates.indexOf(e) === -1 : this.disabledDates.indexOf(e) > -1;
    },
    isDisabled(e) {
      return this.isDateDisabled(e) || this.isBeforeMinDate(e) || this.isAfterEndDate(e);
    },
    previousMonth() {
      this.startingDate = this.subtractMonths(this.months[0].firstDateOfMonth), this.months.unshift(this.getMonth(this.startingDate)), this.months.splice(this.months.length - 1, 1), this.$emit("previous-month", this.visibleMonths), this.resetFocusedDate(!1);
    },
    nextMonth() {
      this.startingDate = this.addMonths(this.months[this.months.length - 1].firstDateOfMonth), this.months.push(this.getMonth(this.startingDate)), this.months.splice(0, 1), this.$emit("next-month", this.visibleMonths), this.resetFocusedDate(!0);
    },
    subtractMonths(e) {
      return g(O(e, 1), this.dateFormat);
    },
    addMonths(e) {
      return g(z(e, 1), this.dateFormat);
    },
    toggleDatepicker() {
      this.showDatepicker ? this.closeDatepicker() : this.openDatepicker();
    },
    updateMonth(e, t, s) {
      const a = s.target.value, r = this.monthNames.indexOf(a);
      if (!this.isMonthDisabled(t, r)) {
        const n = R(H(this.startingDate, r), t);
        this.startingDate = O(n, e);
      }
      this.generateMonths();
    },
    updateYear(e, t, s) {
      const a = s.target.value, r = R(H(this.startingDate, t), a);
      this.startingDate = O(r, e), this.generateMonths();
    },
    openDatepicker() {
      this.positionDatepicker(), this.setStartDates(), this.triggerElement.classList.add("datepicker-open"), this.showDatepicker = !0, this.initialDate1 = this.dateOne, this.initialDate2 = this.dateTwo, this.$emit("opened"), this.$nextTick(() => {
        this.inline || this.setFocusedDate(this.focusedDate);
      });
    },
    closeDatepickerCancel() {
      this.showDatepicker && (this.selectedDate1 = this.initialDate1, this.selectedDate2 = this.initialDate2, this.$emit("cancelled"), this.closeDatepicker());
    },
    closeDatepicker() {
      this.inline || (this.showDatepicker = !1, this.showKeyboardShortcutsMenu = !1, this.triggerElement.classList.remove("datepicker-open"), this.$emit("closed"));
    },
    openKeyboardShortcutsMenu() {
      this.showKeyboardShortcutsMenu = !0;
      const e = this.$refs["keyboard-shortcus-menu-close"];
      this.$nextTick(() => e.focus());
    },
    closeKeyboardShortcutsMenu() {
      this.showKeyboardShortcutsMenu = !1, this.$nextTick(() => this.setFocusedDate(this.focusedDate));
    },
    apply() {
      this.$emit("apply"), this.closeDatepicker();
    },
    positionDatepicker() {
      const e = Cs(this.triggerElement, ".datepicker-trigger");
      this.triggerPosition = this.triggerElement.getBoundingClientRect(), e ? this.triggerWrapperPosition = e.getBoundingClientRect() : this.triggerWrapperPosition = {
        left: 0,
        right: 0
      };
      const t = document.documentElement.clientWidth || window.innerWidth;
      this.viewportWidth = t + "px", this.isMobile = t < 768, this.isTablet = t >= 768 && t <= 1024, this.showMonths = this.isMobile ? 1 : this.isTablet && this.monthsToShow > 2 ? 2 : this.monthsToShow, this.$nextTick(function() {
        const s = document.getElementById(this.wrapperId);
        if (!this.triggerElement || !s)
          return;
        const a = this.triggerElement.getBoundingClientRect().left + s.getBoundingClientRect().width;
        this.alignRight = a > t;
      });
    }
  }
}, Ns = ["id"], Hs = {
  key: 0,
  class: "asd__mobile-header asd__mobile-only"
}, Rs = ["aria-label"], As = {
  key: 1,
  class: "asd__mobile-close-icon",
  "aria-hidden": "true"
}, Bs = {
  class: "asd__datepicker-header"
}, zs = {
  class: "asd__change-month-button asd__change-month-button--previous"
}, Ks = ["aria-label"], Ps = {
  key: 1,
  viewBox: "0 0 1000 1000"
}, Us = /* @__PURE__ */ D("path", {
  d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z"
}, null, -1), Vs = [Us], Gs = {
  class: "asd__change-month-button asd__change-month-button--next"
}, Js = ["aria-label"], Xs = {
  key: 1,
  viewBox: "0 0 1000 1000"
}, Zs = /* @__PURE__ */ D("path", {
  d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"
}, null, -1), js = [Zs], Qs = {
  class: "asd__month-name"
}, qs = {
  key: 0,
  class: "asd__month-year-select-container"
}, ea = ["onUpdate:modelValue", "tabindex", "onChange"], ta = ["value", "aria-disabled"], sa = /* @__PURE__ */ D("svg", {
  class: "asd__month-year-select-icon",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */ D("path", {
  d: "M12 16C12.2735 16 12.5213 15.8902 12.7018 15.7123L17.707 10.7071C18.0976 10.3166 18.0976 9.68345 17.707 9.29293C17.3165 8.90241 16.6834 8.90241 16.2928 9.29293L12.0003 13.5855L7.70479 9.29004C7.31376 8.90241 6.68255 8.90327 6.29289 9.29293C5.90237 9.68345 5.90237 10.3166 6.29289 10.7071C6.29746 10.7117 7.95743 12.3715 11.2728 15.6865C11.4551 15.8795 11.7135 16 12 16Z"
})], -1), aa = {
  key: 1
}, ra = {
  key: 2,
  class: "asd__month-year-select-container"
}, na = ["tabindex", "onUpdate:modelValue", "onChange"], ia = ["value"], oa = ["value"], ha = /* @__PURE__ */ D("svg", {
  class: "asd__month-year-select-icon",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */ D("path", {
  d: "M12 16C12.2735 16 12.5213 15.8902 12.7018 15.7123L17.707 10.7071C18.0976 10.3166 18.0976 9.68345 17.707 9.29293C17.3165 8.90241 16.6834 8.90241 16.2928 9.29293L12.0003 13.5855L7.70479 9.29004C7.31376 8.90241 6.68255 8.90327 6.29289 9.29293C5.90237 9.68345 5.90237 10.3166 6.29289 10.7071C6.29746 10.7117 7.95743 12.3715 11.2728 15.6865C11.4551 15.8795 11.7135 16 12 16Z"
})], -1), la = {
  key: 3
}, da = {
  class: "asd__month-table"
}, ca = {
  "aria-hidden": "true"
}, ua = {
  class: "asd__days-legend"
}, fa = ["data-date", "tabindex", "aria-label", "onMouseover"], Da = ["date", "disabled", "onClick"], pa = {
  class: "asd__keyboard-shortcuts-title"
}, ya = ["aria-label"], ga = {
  key: 1,
  class: "asd__mobile-close-icon",
  "aria-hidden": "true"
}, va = {
  class: "asd__keyboard-shortcuts-list"
}, ma = ["aria-label"], ba = {
  key: 1,
  class: "asd__action-buttons"
}, _a = {
  key: 2,
  class: "asd__keyboard-shortcuts-trigger-wrapper"
}, Ma = ["aria-label"], wa = /* @__PURE__ */ D("span", null, "?", -1), ka = [wa];
function Sa(e, t, s, a, r, n) {
  const h = V("resize-select"), f = V("click-outside");
  return l(), ve(me, {
    name: "asd__fade"
  }, {
    default: G(() => [W((l(), d("div", {
      id: r.wrapperId,
      class: E(["asd__wrapper", n.wrapperClasses]),
      style: T(n.showFullscreen ? void 0 : n.wrapperStyles)
    }, [n.showFullscreen ? (l(), d("div", Hs, [D("button", {
      class: "asd__mobile-close",
      onClick: t[0] || (t[0] = (...i) => n.closeDatepicker && n.closeDatepicker(...i)),
      "aria-label": r.ariaLabels.closeDatepicker
    }, [e.$slots["close-icon"] ? Y(e.$slots, "close-icon", {
      key: 0
    }) : (l(), d("div", As, "X"))], 8, Rs), D("h3", null, m(s.mobileHeader || n.mobileHeaderFallback), 1)])) : M("", !0), D("div", Bs, [D("div", zs, [D("button", {
      onClick: t[1] || (t[1] = (...i) => n.previousMonth && n.previousMonth(...i)),
      type: "button",
      "aria-label": r.ariaLabels.previousMonth
    }, [e.$slots["previous-month-icon"] ? Y(e.$slots, "previous-month-icon", {
      key: 0
    }) : (l(), d("svg", Ps, Vs))], 8, Ks)]), D("div", Gs, [D("button", {
      onClick: t[2] || (t[2] = (...i) => n.nextMonth && n.nextMonth(...i)),
      type: "button",
      "aria-label": r.ariaLabels.nextMonth
    }, [e.$slots["next-month-icon"] ? Y(e.$slots, "next-month-icon", {
      key: 0
    }) : (l(), d("svg", Xs, js))], 8, Js)])]), D("div", {
      class: "asd__inner-wrapper",
      style: T(n.innerStyles)
    }, [be(_e, {
      name: "asd__list-complete",
      tag: "div"
    }, {
      default: G(() => [(l(!0), d(k, null, S(r.months, (i, u) => (l(), d("div", {
        key: i.firstDateOfMonth,
        class: E(["asd__month", {
          hidden: u === 0 || u > r.showMonths
        }]),
        style: T(n.monthWidthStyles)
      }, [D("div", Qs, [s.showMonthYearSelect ? (l(), d("div", qs, [W((l(), d("select", {
        "onUpdate:modelValue": (o) => i.monthName = o,
        class: "asd__month-year-select",
        "aria-label": "Select a month",
        tabindex: u === 0 || u > r.showMonths ? -1 : 0,
        onChange: (o) => n.updateMonth(u, i.year, o)
      }, [(l(!0), d(k, null, S(r.monthNames, (o, y) => (l(), d("option", {
        value: o,
        "aria-disabled": n.isMonthDisabled(i.year, y),
        key: `month-${u}-${o}`
      }, m(o), 9, ta))), 128))], 40, ea)), [[J, i.monthName], [h]]), s.showMonthYearSelect ? Y(e.$slots, "select-icon", {
        key: 0
      }, () => [sa]) : M("", !0)])) : (l(), d("span", aa, m(i.monthName), 1)), s.showMonthYearSelect ? (l(), d("div", ra, [s.showMonthYearSelect ? W((l(), d("select", {
        key: 0,
        class: "asd__month-year-select",
        "aria-label": "Select a year",
        tabindex: u === 0 || u > r.showMonths ? -1 : 0,
        "onUpdate:modelValue": (o) => i.year = o,
        onChange: (o) => n.updateYear(u, i.monthNumber - 1, o)
      }, [r.years.indexOf(i.year) === -1 ? (l(), d("option", {
        value: i.year,
        key: `month-${u}-${e.year}`,
        disabled: !0
      }, m(i.year), 9, ia)) : M("", !0), (l(!0), d(k, null, S(r.years, (o) => (l(), d("option", {
        value: o,
        key: `month-${u}-${o}`
      }, m(o), 9, oa))), 128))], 40, na)), [[J, i.year]]) : M("", !0), s.showMonthYearSelect ? Y(e.$slots, "select-icon", {
        key: 1
      }, () => [ha]) : M("", !0)])) : (l(), d("span", la, " " + m(i.year), 1))]), D("table", da, [D("thead", ca, [D("tr", ua, [(l(!0), d(k, null, S(r.daysShort, (o, y) => (l(), d("th", {
        class: "asd__day-title",
        key: y
      }, m(o), 1))), 128))])]), D("tbody", null, [(l(!0), d(k, null, S(i.weeks, (o, y) => (l(), d("tr", {
        class: "asd__week",
        key: y
      }, [(l(!0), d(k, null, S(o, ({
        fullDate: c,
        dayNumber: _
      }, I) => (l(), d("td", {
        class: E(["asd__day", {
          "asd__day--enabled": _ !== 0,
          "asd__day--empty": _ === 0,
          "asd__day--disabled": n.isDisabled(c),
          "asd__day--selected": c && (r.selectedDate1 === c || r.selectedDate2 === c),
          "asd__day--in-range": n.isInRange(c),
          "asd__day--today": c && n.isToday(c),
          "asd__selected-date-one": c && c === r.selectedDate1,
          "asd__selected-date-two": c && c === r.selectedDate2
        }]),
        key: I + "_" + _,
        "data-date": c,
        ref_for: !0,
        ref: `date-${c}`,
        tabindex: n.isDateVisible(c) && n.isSameDate(r.focusedDate, c) ? 0 : -1,
        "aria-label": n.isDateVisible(c) ? n.getAriaLabelForDate(c) : !1,
        style: T(n.getDayStyles(c)),
        onMouseover: () => {
          n.setHoverDate(c);
        }
      }, [_ ? (l(), d("button", {
        key: 0,
        class: "asd__day-button",
        type: "button",
        tabindex: "-1",
        date: c,
        disabled: n.isDisabled(c),
        onClick: () => {
          n.selectDate(c);
        }
      }, m(_), 9, Da)) : M("", !0)], 46, fa))), 128))]))), 128))])])], 6))), 128))]),
      _: 3
    }), s.showShortcutsMenuTrigger ? (l(), d("div", {
      key: 0,
      class: E({
        "asd__keyboard-shortcuts-menu": !0,
        "asd__keyboard-shortcuts-show": r.showKeyboardShortcutsMenu
      }),
      style: T(n.keyboardShortcutsMenuStyles)
    }, [D("div", pa, m(r.texts.keyboardShortcuts), 1), D("button", {
      class: "asd__keyboard-shortcuts-close",
      ref: "keyboard-shortcus-menu-close",
      tabindex: "0",
      onClick: t[3] || (t[3] = (...i) => n.closeKeyboardShortcutsMenu && n.closeKeyboardShortcutsMenu(...i)),
      "aria-label": r.ariaLabels.closeKeyboardShortcutsMenu
    }, [e.$slots["close-shortcuts-icon"] ? Y(e.$slots, "close-shortcuts-icon", {
      key: 0
    }) : (l(), d("div", ga, "X"))], 8, ya), D("ul", va, [(l(!0), d(k, null, S(r.keyboardShortcuts, (i, u) => (l(), d("li", {
      key: u
    }, [D("span", {
      class: "asd__keyboard-shortcuts-symbol",
      "aria-label": i.symbolDescription
    }, m(i.symbol), 9, ma), Me(" " + m(i.label), 1)]))), 128))])], 6)) : M("", !0)], 4), s.mode !== "single" && s.showActionButtons ? (l(), d("div", ba, [D("button", {
      onClick: t[4] || (t[4] = (...i) => n.closeDatepickerCancel && n.closeDatepickerCancel(...i)),
      type: "button"
    }, m(r.texts.cancel), 1), D("button", {
      ref: "apply-button",
      onClick: t[5] || (t[5] = (...i) => n.apply && n.apply(...i)),
      style: T({
        color: r.colors.selected
      }),
      type: "button"
    }, m(r.texts.apply), 5)])) : M("", !0), s.showShortcutsMenuTrigger ? (l(), d("div", _a, [D("button", {
      class: "asd__keyboard-shortcuts-trigger",
      "aria-label": r.ariaLabels.openKeyboardShortcutsMenu,
      tabindex: "0",
      onClick: t[6] || (t[6] = (...i) => n.openKeyboardShortcutsMenu && n.openKeyboardShortcutsMenu(...i))
    }, ka, 8, Ma)])) : M("", !0)], 14, Ns)), [[we, r.showDatepicker], [f, n.handleClickOutside]])]),
    _: 3
  });
}
const de = /* @__PURE__ */ Ws($s, [["render", Sa]]), Ta = {
  beforeMount: function(e, t, s) {
    e.event = function(a) {
      e === a.target || e.contains(a.target) || t.value(a);
    }, document.body.addEventListener("click", e.event), document.body.addEventListener("touchstart", e.event);
  },
  unmounted: function(e) {
    document.body.removeEventListener("click", e.event), document.body.removeEventListener("touchstart", e.event);
  }
}, Ya = {
  updated: ce,
  mounted: ce
};
function ce(e, t, s) {
  const a = document.createElement("select");
  a.className = e.className;
  const r = document.createElement("option");
  r.textContent = e.value, a.appendChild(r), e.parentNode.appendChild(a);
  const n = a.closest(".asd__wrapper"), h = n.style.display;
  n.style.display = "inline-block", e.style.width = a.offsetWidth + "px", n.style.display = h, a.parentNode.removeChild(a);
}
const Fa = {
  install(e, t) {
    e.directive("click-outside", Ta), e.directive("resize-select", Ya), e.component(de.name, {
      ...t,
      ...de
    });
  }
};
typeof window < "u" && window.Vue && (window.AirbnbStyleDatepicker = Fa);
export {
  Fa as default
};
